import React, { createContext, useContext, useState, useCallback, useMemo, useEffect } from 'react';
import { TRANSLATIONS } from './translations';
import { useAuth } from '../context/AuthContext';
import api from '../api/client';

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const { user } = useAuth();
  const [lang, setLangState] = useState(() => localStorage.getItem('kmt_lang') || 'EN');

  // Adopt the language saved on the user's account once it loads (cross-device persistence)
  useEffect(() => {
    if (user?.lang && user.lang !== lang) {
      setLangState(user.lang);
      localStorage.setItem('kmt_lang', user.lang);
    }
  }, [user?.lang]); // eslint-disable-line react-hooks/exhaustive-deps

  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem('kmt_lang', l);
    // Persist to the user's account so the choice follows them across devices
    if (user) api.setLanguage(l).catch(() => {});
  }, [user]);

  const t = useCallback((key) => {
    const dict = TRANSLATIONS[lang] || TRANSLATIONS.EN;
    return dict[key] || TRANSLATIONS.EN[key] || key;
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);

  return (
    <I18nContext.Provider value={value}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('useI18n must be used within I18nProvider');
  return ctx;
}

export const LANG_LABELS = { EN: 'EN', HI: 'हि', PA: 'ਪੰ' };
